import { useEffect, useRef, useState } from "react";
import AsideIllustration from "../components/asideIllustration/AsideIllustration";
import Header from "../components/global/header/Header";
import ScrollerContainer from "../components/global/scroller/ScrollerContainer";
import pages from "../assets/pagesParts/pages";
import ProjectImage from "../components/projetsList/ProjectImage";
import Social from "../components/global/social/Social";

import { ThemeContext, themes } from "../contexts/theme";
import traking, { visitHandle } from "../lib/event/tracker";
import loadProjects from "../lib/loaders/loadProjects";
import Cv from "../components/global/cvButton/Cv";
import Head from "next/head";
import ChatContainer from "../components/global/chat/ChatContainer";
import loadTypes from "../lib/loaders/loadTypes";
import { ImageProjectContext, ImageProjectCtx } from "../contexts/imageProject";
import React  from "react";

const PageContext = React.createContext();
export const usePageContext = () => React.useContext(PageContext);

export default function Home({ staticProjects, staticTypes }) {
  pages[2].staticProps = { staticProjects, staticTypes };
  const [isProject, setIsProject] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const pageName = pages?.[pageNumber]?.name ?? "Unknown Page";
  const firstRender = useRef(true);

  const lastPageNumber = useRef(0);

  useEffect(() => {
    if (!firstRender.current)
      window.sessionStorage.setItem("slider-pos", pageNumber);

    if (pageNumber == 2) setIsProject(true);
    else {
      if(lastPageNumber.current == 2) {
        setTimeout(() => {
          setIsProject(false);
        }, 100);
      }else setIsProject(false);
    }
    traking({ eventAction: "PageChange", eventName: "goToPage" + pageNumber }).then();
    lastPageNumber.current = pageNumber;

    }, [pageNumber, firstRender]);

  useEffect(() => {
    visitHandle().then();
  }, []);
  useEffect(() => {
    firstRender.current = false;
    setPageNumber(
      Math.min(Math.max(Number(window.sessionStorage.getItem("slider-pos")) || 0, 0), pages.length - 1) || pageNumber
    );
  }, []);

  const handlePageChange = (type) => {
    if (typeof type == "number") return setPageNumber(type);
    if (type == "prev") {
      if (pageNumber > 0)
        setPageNumber((p) => p  - 1)
    } else {
      if (pageNumber < pages.length - 1)
        setPageNumber((p) => p + 1)
    }
  };


  return (
    <>
      <Head>
        <title>Axel Godefroy - Portfolio</title>
        <meta name="title" content="Axel Godefroy - Portfolio" />

        <meta
          name="description"
          content="Portfolio - Axel Godefroy, Étudiant en DUT MMI (Métiers du multimédia et de l'internet), Webdesigner, Développeur Web"
        />
        <meta
          name="keywords"
          content="Développeur Web, Webdesigner, Portfolio, Étudiant, Axel Godefroy, DUT"
        />
        <meta
          property="og:image"
          content="https://axelgodefroy.fr/img/bannerOG.png"
        />
        <meta
          property="og:title"
          content="Axel Godefroy - Portfolio Webdesigner - Développeur Web"
        />
        <meta
          property="og:description"
          content="Découvrez  mon portfolio,Je suis étudiant en DUT MMI &amp; développeur web et webdesigner en freelance"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Project",
              name: "Axel Godefroy",
              alternateName: "Axel G",
              url: "https://axelgodefroy.fr",
              logo: "https://axelgodefroy.fr/img/logo.png",
              sameAs: [
                "https://www.youtube.com/channel/UCKx-eTek7eR34K_pxkTyIbQ",
                "https://5euros.com/profil/axel-g",
                "https://www.linkedin.com/in/axel-g-4110ba1b0",
                "https://www.pinterest.fr/axelgodefroy11",
              ],
            }),
          }}
        ></script>
      </Head>
      <PageContext.Provider value={{
        pageNumber,
        pageName
      }}>
        <ThemeContext.Provider value={isProject ? themes.dark : themes.light}>
          <ImageProjectContext.Provider value={ImageProjectCtx()}>
            <main
              className="mainHome"
              style={{ "--background-color": isProject ? "#121212" : 'white', "--text-color":  isProject ? "white" : "currentColor"}}
              data-project-view={isProject}
            >
              <Header setPageNumber={setPageNumber} />
              <div
                id="main-content"
              >
                <ScrollerContainer
                  {...{
                    pageNumber,
                    setPageNumber: handlePageChange,
                    pages,
                  }}
                />
                <AsideIllustration src={pages[pageNumber].illu} />
                <Cv isMobile={true} />
                <ProjectImage />
              </div>
              <Social />
            </main>
            <ChatContainer />
          </ImageProjectContext.Provider>
        </ThemeContext.Provider>
      </PageContext.Provider>
    </>
  );
}

export const getStaticProps = async () => {
  const { projects } = await loadProjects();

  const { types } = await loadTypes();
  return {
    props: {
      staticProjects: projects,
      staticTypes: types,
    },
  };
};
